import type { GlobalConfigInput, GlobalConfigVersion } from "@/lib/api";

/**
 * PUT /api/admin/config replaces the whole editable document and creates a
 * new version (docs/API_CONTRACT.md). Every editing screen only touches a
 * subset of fields, so mutations must start from the full current config and
 * override just their slice - otherwise saving from one page could silently
 * clobber fields owned by another page (e.g. Feature Flags overwriting the
 * app mode set from App Status).
 */
export function toConfigInput(version: GlobalConfigVersion): GlobalConfigInput {
  return {
    appMode: version.appMode,
    appEnabled: version.appEnabled,
    maintenanceMessage: version.maintenanceMessage,
    minimumVersion: version.minimumVersion,
    minimumVersionCode: version.minimumVersionCode,
    forceUpdate: version.forceUpdate,
    features: version.features,
    olivia: version.olivia,
  };
}
